module.exports = __webpack_public_path__ + "static/media/slogan.fe0b89b5.svg";